export default "__VITE_ASSET__7bdb2d87__"